import React from 'react';

import { BaseAutocompleteProps } from '@lyearn/ui';
import UserSearch from '@/components/UsersSearch';
import { TagValues } from '@/modules/corporate/modules/tags/types';
import { FilterOperatorEnum, TagUnion } from '@/types/schema';

type AutocompleteProps<T> = BaseAutocompleteProps<T, false, false, false>;

export type FilterValueProps = {
  onFilterValueChange: (value?: string) => void;
  filterValue?: string | null;
  tag?: TagUnion | null;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  operator?: FilterOperatorEnum;
  disableDateValueTypeSelector?: boolean;
  classes?: AutocompleteProps<any>['classes'];
  size?: 'medium' | 'large';
  placeholder?: string;
};

export type UserFilterProps = FilterValueProps & {
  placeholder?: string;
  size?: AutocompleteProps<any>['size'];
  clearOnBlur?: boolean;
  showEmail?: boolean;
  groupIds?: string[];
  crossSubWorkspace?: boolean;
  classes?: React.ComponentProps<typeof UserSearch>['classes'];
  excludeUsers?: string[];
};

export enum RelativeDateFilterOperatorEnumSM {
  Last = 'last',
  Next = 'next',
  Now = 'now',
  Previous = 'previous',
  This = 'this',
}

export enum DateValueTypeEnumSM {
  SpecificDate = 'static',
  Dynamic = 'dynamic',
}

export type OnFilterChange = {
  tagValues?: TagValues;
  offsetRelation?: RelativeDateFilterOperatorEnumSM;
  dateValueType?: DateValueTypeEnumSM;
  offsetDays?: number;
};
